<template>
  <div>
    <v-row>
      <v-col cols="5">
        <template v-if="type == 'booking-daily'">
          <div class="black--text font-weight-bold font-size-20" style="font-size: 16px;">{{ $t('booking.regular_booking_date') }}</div>
          <div style="font-size: 13px;">{{ $t('booking.start_and_end_regular_booking_date') }}</div>
        </template>
        <template v-else>
          <div class="black--text font-weight-bold font-size-20" style="font-size: 16px;">{{ $t('bill.auto_bill_date') }}</div>
          <div style="font-size: 13px;">{{ $t('bill.start_and_end_auto_bill_date') }}</div>
        </template>
        <div class="d-flex mb-2 mt-2">
          <v-menu 
            v-model="menuStartDate" 
            :close-on-content-click="false" 
            transition="scale-transition" 
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field 
                :value="$moment(form.startDate).format('D MMM YYYY')" 
                outlined
                dense
                hide-details
                readonly
                v-bind="attrs"
                v-on="on"
                style="flex: 50%;"
                class="me-1"
                prepend-inner-icon="mdi-calendar"
                :disabled="form.loopType == 'manual' || disabled"
              />
            </template>
            <v-date-picker 
              v-model="form.startDate" 
              no-title locale="th" 
              @input="menuStartDate = false; changeLoopType()"
              :header-date-format="$helper.headerDateFormat"
              :year-format="$helper.yearFormat"
              :min="minStartDate"
              :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
            />
          </v-menu>
          <v-menu 
            v-model="menuEndDate" 
            :close-on-content-click="false" 
            transition="scale-transition" 
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field 
                :value="$moment(form.endDate).format('D MMM YYYY')" 
                outlined
                dense
                hide-details
                readonly
                v-bind="attrs"
                v-on="on"
                style="flex: 50%;"
                class="ms-1"
                prepend-inner-icon="mdi-calendar"
                :disabled="form.loopType == 'manual' || disabled"
              />
            </template>
            <v-date-picker 
              v-model="form.endDate" 
              no-title locale="th" 
              @input="menuEndDate = false; changeLoopType()"
              :header-date-format="$helper.headerDateFormat"
              :year-format="$helper.yearFormat"
              :min="maxStartDate"
              :weekday-format="$helper.formatWeekday" :month-format="$helper.formatMonth"
            />
          </v-menu>
        </div>
        <div v-if="type == 'booking-daily'" class="mt-4">
          <div class="black--text font-weight-bold font-size-20" style="font-size: 16px;">{{ $t('booking.regular_booking_time') }}</div>
          <div style="font-size: 13px;">{{ $t('booking.start_and_end_regular_booking_time') }}</div>
          <div class="d-flex mb-2 mt-2">
            <v-select
              v-model="form.startTime"
              class="me-1" 
              prepend-inner-icon="mdi-clock-outline" 
              outlined
              hide-details
              dense
              :items="$helper.timeLabel().hoursMinutes"
              :disabled="disabled"
              :no-data-text="$t('noinfo')"
            />
            <v-select
              v-model="form.endTime"
              class="ms-1" 
              prepend-inner-icon="mdi-clock-outline" 
              outlined
              hide-details
              dense
              :items="$helper.timeLabel().hoursMinutes"
              :disabled="disabled"
              :no-data-text="$t('noinfo')"
            />
          </div>
        </div>
        <v-select
          v-model="form.loopType"
          :items="loopTypeOptions"
          item-text="text"
          item-value="value"
          :placeholder="type == 'booking-daily' ? $t('booking.select_booking') : $t('bill.select_export_bill')"
          outlined
          dense
          :rules="[rules.required]"
          :hide-details="form.loopType"
          @change="changeLoopType()"
          :disabled="disabled"
          :no-data-text="$t('noinfo')"
        />
        <div v-if="form.loopType == 'everyweek'" class="d-flex mt-3">
          <template v-for="day of weekDays">
            <span 
              :class="`week-day ${ day.isSelect ? 'active' : '' } ${ day.disabled ? 'disabled' : '' }`" 
              @click="changeWeekDay(day)"
            >
              {{ day.text }}
            </span>
          </template>
        </div>
        <div v-if="form.loopType == 'everymonth'" class="d-flex justify-space-between align-center mt-3">
          <div class="black--text font-weight-bold font-size-20" style="font-size: 16px;">
            <template v-if="type == 'booking-daily'">{{ $t('booking.booking_every_date') }}</template>
            <template v-else>{{ $t('bill.export_bill_every_date') }}</template>
          </div>
          <div style="width: 110px;">
            <v-select
              v-model="form.loopDate"
              outlined
              dense
              hide-details
              prepend-inner-icon="mdi-calendar"
              :items="monthDays"
              :rules="[rules.required]"
              @change="calLoopData()"
              :disabled="disabled"
              :no-data-text="$t('noinfo')"
            />
          </div>
        </div>
      </v-col>
      <v-col cols="7" class="px-0 py-0 d-flex justify-center">
        <CustomDatePicker
          v-if="form.loopType == 'manual'"
          v-model="form.loopDays"
          :startDate="form.startDate"
          :endDate="form.endDate"
          multiple
          @onClick="calLoopData()"
          :isDisablePrevious="isDisablePrevious"
          :isDisableNow="isDisableNow"
          :disabled="disabled"
        />
        <CustomDatePicker
          v-else
          :startDate="form.startDate"
          :endDate="form.endDate"
          range
          :isDisablePrevious="isDisablePrevious"
          :isDisableNow="isDisableNow"
          :disabled="disabled"
        />
      </v-col>
      <v-col cols="12" class="py-0" v-if="form.loopType == 'everyday' || type == 'booking-daily'">
        <div v-for="key in Object.keys(loopData)">
          <div v-if="key != 'all' && loopData[key].length" class="d-flex justify-start align-center mt-2">
            <div>
              <div style="font-size: 16px; width: 100px; color: #2E7D32;">
                <b>{{ $moment(key + '-01', 'YYYY-MM-DD').format('MMM YYYY') }}</b>
              </div>
            </div>
            
            <div>
              <v-chip v-for="item of loopData[key]" 
                :key="item"
                class="ma-1 px-4 py-2"
                style="color: #2E7D32; background-color: #E8F5E9; font-size: 15px;"
              >
              {{ $moment(item).date() }}
              <v-icon @click="removeLoopData(item)" right style="color: #2E7D32; font-size: 18px;" v-if="!disabled">
                mdi-close-circle
              </v-icon>
            </v-chip>
            </div>
          </div>
        </div>  
      </v-col>
    </v-row>
    <div class="mt-3 grey--text" v-if="!isHideTextSummary">
      <small v-if="form.loopType">
        <span>
          {{ $t('bill.export_bill') }}{{ loopTypeString[form.loopType] }} {{ $t('bill.start_export_bill_date') }} {{ $moment(form.startDate).format('D MMM YYYY') }} - {{ $moment(form.endDate).format('D MMM YYYY') }} 
          <b class="primary--text" style="font-size: 13px;">{{ $t('all') }} {{ loopData.all.length }} {{ $t('day') }}</b>
        </span>
      </small>
      <small v-else>{{ $t('bill.not_select_export_bill') }}</small>
    </div>
  </div>
</template>
<script>
import CustomDatePicker from "../components/CustomDatePicker";
import moment from "moment";
export default {
  props: {
    startDate: {
      type: String,
      default: moment().add(1, "days").format("YYYY-MM-DD"),
    },
    endDate: {
      type: String,
      default: moment().add(1, "days").format("YYYY-MM-DD"),
    },
    startTime: {
      type: String,
      default: "08:00",
    },
    endTime: {
      type: String,
      default: "20:00",
    },
    loopType: {
      type: String,
      default: null
    },
    loopDate: {
      type: Number,
      default: null
    },
    loopDays: {
      type: Array,
      default: () => []
    },
    loopWeekDays: {
      type: Array,
      default: () => []
    },
    isDisablePrevious: {
      type: Boolean,
      default: true
    },
    isDisableNow: {
      type: Boolean,
      default: false
    },
    isHideTextSummary: Boolean,
    type: String,
    disabled: Boolean
  },
  components: {
    CustomDatePicker
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.$emit("update:loopData", this.loopData)
        for(let key in this.form){
          this.$emit("update:" + key, this.form[key])
        }
        this.$emit("onUpdate", {
          ...this.form,
          loopData: this.loopData
        })
      }
    },
    loopData: {
      deep: true,
      handler() {
        this.$emit("update:loopData", this.loopData)
        for(let key in this.form){
          this.$emit("update:" + key, this.form[key])
        }

        this.$emit("onUpdate", {
          ...this.form,
          loopData: this.loopData
        })
      }
    }
  },
  data() {
    return {
      form: {
        startDate: this.startDate,
        endDate: this.endDate,
        startTime: this.startTime,
        endTime: this.endTime,
        loopType: this.loopType,
        loopDate: this.loopDate,
        loopDays: this.loopDays,
        loopWeekDays: this.loopWeekDays
      },
      loopData: {
        all: []
      },
      rules: {
        required: value => !!value || this.$t('validate.please_input_data'),
      },
      menuStartDate: false,
      menuEndDate: false,
      weekDays: this.$moment.weekdays().map((d, i) => {
        return {
          text: d,
          value: i,
          isSelect: false,
          disabled: true
        }
      }),
      monthDays: new Array(31).fill(0).map((_, i) => i + 1),
      loopTypeString: {
        everyday: this.$t('everyday'),
        everyweek: this.$t('everyweek'),
        everymonth: this.$t('everymonth'),
        manual: this.$t('custom'),
      },
    }
  },
  computed: {
    maxStartDate(){
      if(this.$moment(this.form.startDate) > this.$moment()){
        return this.$moment(this.form.startDate).format("YYYY-MM-DD")
      }else{
        return this.$moment().format("YYYY-MM-DD")
      }
    },
    minStartDate(){
      if (this.isDisableNow) {
        return this.$moment().add(1, 'days').format('YYYY-MM-DD')
      } else if (this.isDisablePrevious) {
        return this.$moment().format('YYYY-MM-DD')
      } else {
        return null
      }
    },
    loopTypeOptions() {
      if (this.type == "booking-daily") {
        return [
          { text: this.$t('booking.booking_every_day'), value: "everyday" },
          { text: this.$t('booking.booking_every_week'), value: "everyweek" },
          { text: this.$t('booking.booking_every_month'), value: "everymonth" },
          { text: this.$t('booking.select_booking_manual'), value: "manual" },
        ]
      } else {
        return [
          { text: this.$t('bill.export_bill_every_day'), value: "everyday" },
          { text: this.$t('bill.export_bill_every_week'), value: "everyweek" },
          { text: this.$t('bill.export_bill_every_month'), value: "everymonth" },
          { text: this.$t('bill.select_export_manual'), value: "manual" },
        ]
      }
    }
  },
  created() {
    this.initData()
  },
  methods: {
    initData() {
      if (this.form.loopWeekDays?.length) {
        for(let day of this.weekDays) day.isSelect = this.form.loopWeekDays.indexOf(day.value) != -1
      }
      this.loopData = { all: [] }
      for (let date of this.form.loopDays) {
        if (!this.loopData[`${this.$moment(date).format("YYYY-MM")}`]) this.loopData[`${this.$moment(date).format("YYYY-MM")}`] = []
        this.loopData[`${this.$moment(date).format("YYYY-MM")}`].push(date)
        this.loopData.all.push(date)
      }
      this.calMonthDays();
      // this.calLoopData()
    },
    changeLoopType(){
      this.form.loopDate = null 
      this.form.loopDays = []
      this.form.loopWeekDays = []
      for(let day of this.weekDays) day.isSelect = false
      this.calMonthDays()
      this.calLoopData(); 
    },
    calMonthDays(){
      this.monthDays = []
      this.weekDays.forEach(d => d.disabled = true)
      let mm = this.$moment(this.form.startDate).subtract(1, "days")
      do {
        mm.add(1, "days")
        if (!this.monthDays.includes(mm.date())) this.monthDays.push(mm.date())
        this.monthDays = this.monthDays.sort((a, b) => a - b)

        this.weekDays.find(d => d.value == mm.day()).disabled = false
      } while (mm < this.$moment(this.form.endDate))
    },
    calLoopData() {
      this.loopData = {
        all: []
      }
      if (this.form.loopType == "everyday") {
        let mm = this.$moment(this.form.startDate).subtract(1, "days")
        do {
          mm.add(1, "days")
          if (!this.loopData[mm.format("YYYY-MM")]) this.loopData[mm.format("YYYY-MM")] = []
          this.loopData[mm.format("YYYY-MM")].push(mm.format("YYYY-MM-DD"))
          this.loopData.all.push(mm.format("YYYY-MM-DD"))
        } while (mm < this.$moment(this.form.endDate))
      } else if (this.form.loopType == "everyweek") {
        let mm = this.$moment(this.form.startDate).subtract(1, "days")
        let days = this.weekDays.filter(d => d.isSelect).map(d => d.value)
        do {
          mm.add(1, "days")
          if (days.indexOf(mm.day()) > -1) {
            if (!this.loopData[mm.format("YYYY-MM")]) this.loopData[mm.format("YYYY-MM")] = []
            this.loopData[mm.format("YYYY-MM")].push(mm.format("YYYY-MM-DD"))
            this.loopData.all.push(mm.format("YYYY-MM-DD"))
          }
        } while (mm < this.$moment(this.form.endDate))
      } else if (this.form.loopType == "everymonth" && this.form.loopDate) {
        let mm = this.$moment(this.form.startDate).subtract(1, "months")
        do {
          mm.add(1, "months")
          let tempMM = this.$moment(mm)
          let daysInMonth = tempMM.daysInMonth()
          let date = parseInt(this.form.loopDate)
          if (this.form.loopDate <= daysInMonth) {
            tempMM.set("date", date)
            if (tempMM.isBetween(this.$moment(this.form.startDate), this.$moment(this.form.endDate), null, '[]')) {
              if (!this.loopData[mm.format("YYYY-MM")]) this.loopData[tempMM.format("YYYY-MM")] = []
              this.loopData[mm.format("YYYY-MM")].push(tempMM.format("YYYY-MM-DD"))
              this.loopData.all.push(tempMM.format("YYYY-MM-DD"))
            }
          }
        } while (mm < this.$moment(this.form.endDate))
      } else if (this.form.loopType == "manual") {
        for (let day of this.form.loopDays) {
          let mm = this.$moment(day)
          if (!this.loopData[mm.format("YYYY-MM")]) this.loopData[mm.format("YYYY-MM")] = []
          this.loopData[mm.format("YYYY-MM")].push(mm.format("YYYY-MM-DD"))
          this.loopData.all.push(mm.format("YYYY-MM-DD"))
        }
        if(this.loopData.all && this.loopData.all.length > 0) {
          this.form.startDate = this.loopData.all[0]
          this.form.endDate = this.loopData.all[this.loopData.all.length - 1]
        } else {
          if (this.isDisableNow) {
            this.form.startDate = this.$moment().add(1, "days").format("YYYY-MM-DD")
            this.form.endDate = this.$moment().add(1, "days").format("YYYY-MM-DD")
          } else {
            this.form.startDate = this.$moment().format("YYYY-MM-DD")
            this.form.endDate = this.$moment().format("YYYY-MM-DD")
          }
        }
      }
    },
    removeLoopData(date) {
      this.loopData = JSON.parse(JSON.stringify(this.loopData))
      this.loopData.all = this.loopData.all.filter(d => d != date)
      if (this.loopData[`${this.$moment(date).format("YYYY-MM")}`]) {
        this.loopData[`${this.$moment(date).format("YYYY-MM")}`] = this.loopData[`${this.$moment(date).format("YYYY-MM")}`].filter(d => d != date)
      }
      this.form.loopDays = this.loopData.all
    },
    changeWeekDay(day) {
      day.isSelect = !day.isSelect
      this.form.loopWeekDays = this.weekDays.filter(d => d.isSelect).map(d => d.value)
      this.calLoopData()
    }
  }
}
</script>
<style lang="scss" scoped>
.week-day{
  color: #2E7D32;
  background-color: #E8F5E9;
  width: 100%;
  text-align: center;
  margin: 0px 2px;
  padding: 8px 2px;
  font-size: 13px;
  border-radius: 5px;
  cursor: pointer;
  &.active{
    background-color: #2E7D32;
    color: white;
  }
  &.disabled{
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
}
</style>
